import React, { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { useFormik } from "formik";
import { Link } from "react_reusable_components";

import Button from "../../components/Button";
import CustomInput from "../../components/CustomInput/CustomInput";
import { ThreeRow, TwoRow } from "../../core/layouts";
import {
  loginValidationSchema,
  fieldNames,
  initialValues,
} from "../../validationSchema";
import variables from "../../themes/base/styles/variables";
import { AuthContext } from "../../globalContext/auth/authProvider";
import { getLocalizedMessage } from "../../UtilityFunctions/utils";
import { AuthService } from "../../services";

const loginFormStyle = {
  middleBottomSectionStyle: {
    justifyContent: "flex-end",
  },
  sectionsStyle: { marginBottom: variables.marginLarge },
  bottomSectionStyle: { marginTop: variables.marginMedium },
  forgotPassword: {
    marginTop: variables.marginMediumLarge,
    fontSize: variables.fontSizeSmall,
    lineHeight: variables.lineHeightLarge,
  },
  threeRowMainStyle: { overflow: "hidden" },
};

const LoginForm = () => {
  const [authState, authDispatch] = useContext(AuthContext);
  const [disabled, setDisabled] = useState(false);

  let navigate = useNavigate();
  const intl = useIntl();

  const {
    values,
    setValues,
    handleBlur,
    handleChange,
    handleSubmit,
    errors,
    touched,
  } = useFormik({
    initialValues,
    onSubmit: function (data) {
      setDisabled(true);
      AuthService.login(data, authDispatch, intl, navigate)
        .then(() => {
          navigate("/login/otp");
        })
        .catch(() => {})//NOSONAR
        .finally(() => {
          setDisabled(false);
        });
    },
    validationSchema: loginValidationSchema(intl),
  });

  useEffect(() => {
    setValues({
      email: authState?.authData?.email,
      password: authState?.authData?.password,
    });
  }, [authState]);

  return (
    <ThreeRow
      style={loginFormStyle.threeRowMainStyle}
      topSection={
        <CustomInput
          required
          placeholder={getLocalizedMessage(intl, "login.placeholder.email")}
          label={getLocalizedMessage(intl, "login.label.email")}
          error={touched[fieldNames.EMAIL] && errors[fieldNames.EMAIL]}
          value={values[fieldNames.EMAIL]}
          onChange={handleChange}
          onBlur={handleBlur}
          name={fieldNames.EMAIL}
        />
      }
      middleSection={
        <TwoRow
          topSection={
            <CustomInput
              required
              placeholder={getLocalizedMessage(
                intl,
                "login.placeholder.password"
              )}
              label={getLocalizedMessage(intl, "login.label.password")}
              isPassword
              error={
                touched[fieldNames.PASSWORD] && errors[fieldNames.PASSWORD]
              }
              value={values[fieldNames.PASSWORD]}
              onChange={handleChange}
              onBlur={handleBlur}
              name={fieldNames.PASSWORD}
            />
          }
          bottomSectionStyle={loginFormStyle.middleBottomSectionStyle}
          bottomSection={
            <Link
              style={loginFormStyle.forgotPassword}
              strong
              onClick={(e) => {
                e.preventDefault();
                navigate("/login/forgot-password");
              }}
            >
              {getLocalizedMessage(intl, "login.forgotPassword")}
            </Link>
          }
        />
      }
      bottomSection={
        <Button disabled={disabled} onClick={handleSubmit}>
          {getLocalizedMessage(intl, "login.button.login")}
        </Button>
      }
      topSectionStyle={loginFormStyle.sectionsStyle}
      middleSectionStyle={loginFormStyle.sectionsStyle}
      bottomSectionStyle={loginFormStyle.bottomSectionStyle}
    />
  );
};

export default LoginForm;
